import React from 'react';
import styles from './fileAvailability.module.scss';

const mappings = [
    {
        id: 'fileName',
        title: 'File Name',
        renderCell: row => <span className={ styles.fileName }>{ row.value }</span>
    },
    {
        id: 'status',
        title: 'Status',
        renderCell: row => (
            <span className={ row.value === 'Available' ? styles.statusAvailable : styles.statusMissing }>
                { row.value }
            </span>
        )
    },
    {
        id: 'download',
        title: '',
        filterable: false,
        renderCell: row => (
            <button
                type="button"
                className={ styles.downloadBtn }
                disabled={ row.original.status !== 'Available' }
                onClick={ () => row.column.getGridProps().downloadFile(row.original.sourceFolder, row.original.fileName) }
            >
                Download
            </button>
        )
    }
];

export default mappings;
